"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    default: mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var react_1 = __importDefault(require("react"));

function useLocalStorage(key, initialValue) {
  void 0 === initialValue && (initialValue = "");

  var _a = react_1.default.useState(function () {
    var value = localStorage.getItem(key) || initialValue;
    return localStorage.setItem(key, value), value;
  }),
      item = _a[0],
      setValue = _a[1];

  return [item, function (newValue) {
    setValue(newValue), window.localStorage.setItem(key, newValue);
  }];
}

exports.default = useLocalStorage;